export const URL =
  "https://dca-bot-alpha-325e210a41d8.herokuapp.com/api/users/";

export const LOGIN_URL = URL + "login/";
export const SIGN_UP_URL = URL + "signup/";
export const PLAN_URL = URL + "select-plan/";

export const BASE_URL = "https://dca-alpha-bot-be-do.alpharoboticsllp.com";
